/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 6/19/19
 * Time: 5:39 PM
 */

module.exports = {
  chart: {
    type: "column",
    height:500
  },
  title: {
    text: "",
    x: -20 //center
  },
  subtitle: {
    text: "",
    x: -20
  },
  xAxis: {
    allowDecimals: false,
    labels: {
      formatter: function() {
        return this.value;
      }
    },
    categories: []
  },
  yAxis: {
    title: {
      text: ""
    },
    labels: {
      formatter: function() {
        return this.value;
      }
    }
  },
  credits: {
    enabled: false
  },
  plotOptions: {
    area: {
      pointStart: 1940,
      marker: {
        enabled: false,
        symbol: "circle",
        radius: 2,
        states: {
          hover: {
            enabled: true
          }
        }
      }
    },
    series: {
      stacking: 'normal',
      borderColor: '#e0e0e0'
    }
  },

  tooltip: {
    formatter: function () {
      return '<b>' +  this.point.category + '</b><br/>' +
        this.series.name + ' : '+
        ' </b>'+ Math.abs(this.point.y) +'</b>'
    }
  },

  series: []

};
